var SupportBasePresentation, SupportGoodsVoucherPresenterPresentation, SupportGoodsVoucherStatusAndNotesPresentation,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportBasePresentation = require('./base');

SupportGoodsVoucherStatusAndNotesPresentation = require('./goods_voucher_messages');

SupportGoodsVoucherPresenterPresentation = (function(superClass) {
  extend(SupportGoodsVoucherPresenterPresentation, superClass);

  function SupportGoodsVoucherPresenterPresentation() {
    return SupportGoodsVoucherPresenterPresentation.__super__.constructor.apply(this, arguments);
  }

  SupportGoodsVoucherPresenterPresentation.prototype.getLookupObject = function() {
    return SupportGoodsVoucherStatusAndNotesPresentation;
  };

  return SupportGoodsVoucherPresenterPresentation;

})(SupportBasePresentation);

module.exports = SupportGoodsVoucherPresenterPresentation;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvcHJlc2VudGVycy9nb29kc192b3VjaGVyX3ByZXNlbnRlci5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC9wcmVzZW50ZXJzL2dvb2RzX3ZvdWNoZXJfcHJlc2VudGVyLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLGdIQUFBO0VBQUE7OztBQUFBLHVCQUFBLEdBQTBCLE9BQUEsQ0FBUSxRQUFSOztBQUMxQiw2Q0FBQSxHQUFnRCxPQUFBLENBQVEsMEJBQVI7O0FBRTFDOzs7Ozs7O3FEQUNMLGVBQUEsR0FBaUIsU0FBQTtXQUNoQjtFQURnQjs7OztHQURxQzs7QUFJdkQsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
